module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"PagSeguroConnectStaging":"PagBank (PagSeguro)","PagSeguroConnect":"PagBank (PagSeguro)"},"en-US":{"PagSeguroConnectStaging":"PagBank (PagSeguro)","PagSeguroConnect":"PagBank (PagSeguro)"}}')
  delete Component.options._Ctor
}
